import {combineReducers} from 'redux'
import Customizer from './customizer/reducer'
import Taskapp from './task-app/reducer'
const reducers = combineReducers({
    Customizer,
    Taskapp,
});

export default reducers;